import React from 'react';

export const MobileModal = () => (
  <div className='mobile-modal'>
    <p>To view the documentation, please open the website from your computer.</p>
  </div>
);
